import React, { FC, useCallback, useState } from 'react';
import cn from 'clsx';
import toast from 'react-hot-toast';

import Card from '@components/elements/Card';
import PollPicker from '@components/modules/PollPicker';
import { FormattedPoll } from '@utils/Poll';
import PollVoterList from '@components/modules/Admin/Poll/VoterList';

import { mutate } from 'swr';
import {
  withdrawVotePoll,
  withdrawAllVotesInGroupPoll,
} from '@sdk/managers/VotesManager';

const AdminVotesPage: FC = () => {
  const [poll, setPoll] = useState<FormattedPoll>();

  const onPollSelect = useCallback(
    (poll: FormattedPoll) => {
      setPoll(poll);
    },
    [setPoll]
  );

  const withdrawVote = useCallback(
    async (userId: string, option: string) => {
      if (!poll) return toast.error('Poll not selected');
      try {
        console.log('withdrawVotePoll', ['id'], poll.id, null, userId, option);
        const res = await toast.promise(
          (async () => {
            let res;
            if (poll.isGroup) {
              console.log('withdrawAllVotesInGroupPoll');
              res = await withdrawAllVotesInGroupPoll(
                userId,
                poll.id,
                'Admin withdraw'
              );
            } else {
              console.log('withdrawVotePoll');
              res = await withdrawVotePoll(
                ['id'],
                poll.id,
                null,
                userId,
                'Admin withdraw'
              );
            }

            await mutate(['/poll/voters', poll.id]).catch((err) =>
              console.log('mutate failed', err)
            );
            return res;
          })(),
          {
            loading: 'Removing vote...',
            success: 'Removed vote',
            error: (err) => err.error || err.message || 'Failed to remove vote',
          }
        );
        console.log(res);
      } catch (err: any) {
        console.log('Unexpected error withdrawVote', err);
      }
    },
    [poll]
  );

  return (
    <React.Fragment>
      <div className="flex flex-col min-h-screen px-4 pt-16 pb-32 bg-blue-light">
        <div>
          <h1 className="mb-4 text-4xl text-white whitespace-pre-line">{`Withdraw vote`}</h1>
        </div>
        <div className="flex flex-col space-y-8">
          <div>
            <h2 className="mb-2 text-white uppercase">Choose Poll</h2>
            <PollPicker onChange={onPollSelect} filter="VOTER" />
          </div>

          <div>
            <h2 className="mb-2 text-white uppercase">
              Select user vote to withdraw
            </h2>
            <Card
              shadowColor="yellow"
              className={cn('p-4', { 'text-center': true })}
            >
              {!poll ? (
                'No Poll selected'
              ) : (
                <PollVoterList pollId={poll.id} onAction={withdrawVote} />
              )}
            </Card>
          </div>

          {/* <div>
            <ButtonMighty
              disabled={selected.length === 0}
              className={cn({ 'opacity-80': selected.length === 0 })}
              color="#00ff43"
              borderColor="#221f20"
              textColor="#221f20"
              text="Withdraw votes"
            />
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminVotesPage;
